import { IUser } from "../../api/services/auth/models";
import { IMyInfoData } from "../../api/services/profile/models";

export class AuthConfig {
  private static readonly tokenKey = "userToken";
  static readonly setToken = (token: string | null) => {
    if (token === null) {
      window.localStorage.removeItem(AuthConfig.tokenKey);
    } else {
      window.localStorage.setItem(AuthConfig.tokenKey, token);
    }
  };
  static readonly getToken: () => string | null = () => {
    return window.localStorage.getItem(AuthConfig.tokenKey);
  };

  private static readonly refreshTokenKey = "userRefreshToken";
  static readonly setRefreshToken = (token: string | null) => {
    if (token === null) {
      window.localStorage.removeItem(AuthConfig.refreshTokenKey);
    } else {
      window.localStorage.setItem(AuthConfig.refreshTokenKey, token);
    }
  };
  static readonly getRefreshToken: () => string | null = () => {
    return window.localStorage.getItem(AuthConfig.refreshTokenKey);
  };

  private static readonly expiresAt = "expiresAt";
  static readonly setExpiresAt = (time: string | null) => {
    if (time === null) {
      window.localStorage.removeItem(AuthConfig.expiresAt);
    } else {
      window.localStorage.setItem(AuthConfig.expiresAt, time);
    }
  };
  static readonly getExpiresAt: () => string | null = () => {
    return window.localStorage.getItem(AuthConfig.expiresAt);
  };

  private static readonly userInfoKey = "userInfo";
  static readonly setUserInfo = (info?: IUser | null) => {
    if (info) {
      const userInfoString = JSON.stringify(info);
      window.localStorage.setItem(AuthConfig.userInfoKey, userInfoString);
    } else {
      window.localStorage.removeItem(AuthConfig.userInfoKey);
    }
  };
  static readonly getUserInfo: () => IUser = () => {
    const userInfo = window.localStorage.getItem(AuthConfig.userInfoKey);
    if (userInfo) {
      return JSON.parse(userInfo);
    }
    return null;
  };

  private static readonly myInfoKey = "myInfo";
  static readonly setMyInfo = (info?: IMyInfoData | null) => {
    if (info) {
      const myInfoString = JSON.stringify(info);
      window.localStorage.setItem(AuthConfig.myInfoKey, myInfoString);
    } else {
      window.localStorage.removeItem(AuthConfig.myInfoKey);
    }
  };
  static readonly getMyInfo: () => IMyInfoData = () => {
    const myInfoString = window.localStorage.getItem(AuthConfig.myInfoKey);
    if (myInfoString) {
      return JSON.parse(myInfoString);
    }
    return null;
  };

  private static readonly appTokenKey = "appTokenKey";
  static readonly setAppToken = (token: string | null) => {
    if (token === null) {
      window.localStorage.removeItem(AuthConfig.appTokenKey);
    } else {
      window.localStorage.setItem(AuthConfig.appTokenKey, token);
    }
  };
  static readonly getAppToken: () => string | null = () => {
    return window.localStorage.getItem(AuthConfig.appTokenKey);
  };

  private static readonly zendeskTokenKey = "userZendeskToken";
  static readonly setZendeskToken = (token: string | null) => {
    if (token === null) {
      window.localStorage.removeItem(AuthConfig.zendeskTokenKey);
    } else {
      window.localStorage.setItem(AuthConfig.zendeskTokenKey, token);
    }
  };
  static readonly getZendeskToken: () => string | null = () => {
    return window.localStorage.getItem(AuthConfig.zendeskTokenKey);
  };
}
